import { get } from 'lodash';

export const sendersIsLoadingSelector = state => get( state, 'senders.isLoading', false );
export const sendersByIdSelector = state => get( state, 'senders.byId', {} );
export const allSendersIdsSelector = state => get( state, 'senders.allIds', [] );
